var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.show)?_c('progress1',{attrs:{"files":_vm.files},on:{"cancelUpload":_vm.cancelUpload}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }